import React from "react";
import { connect } from "react-redux";
import { Strings } from "../../Resources/Strings/i18n";
import { Modal } from "../CustomModal/Modal";
import Button from "@material-ui/core/Button";
import CommonUtils from "../../Utils/CommonUtils";
import "./SuccessModal.scss"


function SuccessModal(props) {
  return (
    <div className="SuccessOtpContainer">
      <Modal
        show={props.showSuccessModal}
        handleClose={props.hideModal}
        parent={"exitsession"}
      >
        {
          <div>
            <div className="successOtp">
              <div className="successModal">
                <div className="modalTitle">
                  <p id="successTitle">
                    <span id="successText">{Strings("Success!")}</span>
                  </p>
                </div>
                <div className="successContainer">
                  <div className="successContent">
                    <p>{props.SuccessMessage}</p>
                  </div>
                </div>
                <Button
                  className="successBtn"
                  onClick={() => {
                  props.closeSuccessModal()
                  }}
                >
                  {Strings("Ok")}
                </Button>
              </div>
            </div>
          </div>
        }
      </Modal>
    </div>
      

  );
}

const mapStateToProps = (state) => {
    return {
      userInfo: CommonUtils.getInvitedTokenInfo(state),
    };
  };
  
  export default connect(mapStateToProps)(SuccessModal);
  
